export default __webpack_public_path__ + "static/media/price-management-orange-icon.642911b1.png";